import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  button: {
    flexShrink: 0,
    minWidth: 32,
    minHeight: 32,
    padding: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.default,
    },
    '@media (hover: none) and (pointer: coarse)': {
      minWidth: theme.spacing(5.5),
      minHeight: theme.spacing(5.5),
    },
  },
}));

type TabScrollButtonProps = {
  direction: 'left' | 'right';
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

// MUI hides its default scroll buttons below sm; this replacement keeps the
// FontAwesome controls visible on every viewport while tabs are overflowing.
const TabScrollButton: FC<TabScrollButtonProps> = ({ direction, disabled, onClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (disabled) return null;

  return (
    <IconButton
      className={classes.button}
      aria-label={
        direction === 'left'
          ? t('parties:scroll-tabs-left')
          : t('parties:scroll-tabs-right')
      }
      onClick={onClick}
      size="large"
    >
      <FontAwesomeIcon icon={direction === 'left' ? faChevronLeft : faChevronRight} />
    </IconButton>
  );
};

export default TabScrollButton;
